// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"572c8245","498":"66d8f4bb","513":"d65b6a36","703":"f893430f","787":"6e1de137","986":"12928da9"}[chunkId] + ".chunk.js";
};